import _ from 'lodash';
export var isEmbedEnabled = function (_a) {
    var videoItem = _a.videoItem;
    return _.get(videoItem, 'embedOptions.enabled', false);
};
